export default "__VITE_ASSET__CrkFNuU8__"